<template>
    <div>
        <h1 style="padding: 20px; font-size: 20px;">세션 만료 또는 잘못된 접근 입니다.<br> Dportal을 통해 다시 로그인을 시도해주세요.</h1>
    </div>
</template>

<script>
export default {
  name: 'SessionTimeout'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/SessionTimeout.vue